var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("Home")]),_c('b-jumbotron',{attrs:{"header":"KONUK","lead":_vm.msg}},[_c('p',[_vm._v("For more information visit website")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }